<!-- <div class="order__view" *ngIf="db.order_Detail">
  <img src="/assets/icons/order-null.svg" alt="">
  <p class="ion_text_center">No Orders Available</p>
</div> -->
<div class="d__flex" >
  <div class="orders__list">
    <div *ngIf="db.allOrders && db.allOrders.length != 0" class="orderDatas">
      <div class="all__Orders d__flex mouse align-c animated fadeInUp" *ngFor="let item of db.allOrders" [class.active__item]="(item && item.name) == (db.items && db.items.name)" (click)="!db.ismobile?order_click(item):showOrders(item)">
        <div>
        <h6 class="order__id">{{item.name}}</h6>
        <span class="d__flex" *ngIf="false">
          <h6 class="data__time">{{item.order_date | date: 'MM/dd/yyyy'}}</h6>
          <!-- <h6 class="datas__time">{{item.order_time}}</h6> -->
        </span>
        </div>
        <div><span class="order_status" [class.success]="item.status == 'Completed'" [class.delivered_color]="item.status == 'Delivered'" [class.in_progress__color]="item.status == 'Cancelled'" [class.inprogress]="item.status == 'In Process'" [class.placed]="item.status == 'Placed'" [class.shipped]="item.status == 'Shipped'">{{item.status}}</span></div>
        <div class="price open_sans__font">{{item.total_amount | currency:db.currency}}</div>
        <div class="d__flex payment__status"><span class="dot" [class.paid-b]="item.payment_status == 'Paid'" [class.pending]="item.payment_status == 'Pending'" [class.authorized]="item.payment_status == 'Authorized'"  [class.partialypaid]="item.payment_status == 'Partially Paid'"></span>
          <p [class.paid-c]="item.payment_status == 'Paid'" [class.pend]="item.payment_status == 'Pending'" [class.auth]="item.payment_status == 'Authorized'" [class.partial]="item.payment_status == 'Partially Paid'">{{item.payment_status}}</p>
        </div>
        <!-- </div> -->
      </div>
    </div>
    <div class="all__Orders" *ngIf="db.allOrders && db.allOrders.length == 0 && !is_order">
      <ion-item *ngFor="let i of [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15]">
        <ion-label>
          <h3 class="d__flex just-s">
            <ion-skeleton-text animated style="width: 15%; height: 16px"></ion-skeleton-text>
            <ion-skeleton-text animated style="width: 15%; height: 16px"></ion-skeleton-text>
            <ion-skeleton-text animated style="width: 15%; height: 16px"></ion-skeleton-text>
            <ion-skeleton-text animated style="width: 10%; height: 16px"></ion-skeleton-text>
          </h3>
        </ion-label>
      </ion-item>
    </div>
    <div class="order__view" *ngIf="db.allOrders && db.allOrders.length ==0 && is_order">
      <img src="assets/icons/order-null.svg" alt="">
      <p class="ion_text_center">No Orders Available</p>
    </div>
  </div>
  <div *ngIf="false && db.items && !db.ismobile" class="payment__list">
    <div class="d__flex_justify">
      <div *ngIf="db.items" class="cus__date__time__data">
        <div class="order__id">{{db.items.name}}</div>
        <div class="d__flex">
          <div class="data__time">{{db.items.order_date | date: 'MM/dd/yyyy'}}</div>
          <div *ngIf="db.items.order_time" class="datas__time"> at {{db.items.order_time}}</div>
        </div>
      </div>
      <ion-buttons class="printMenu__button" (click)="printOrder(db.items)">
        <ion-button color="" fill="clear">
          <ion-icon src="assets/icons/Print.svg"></ion-icon>Print
        </ion-button>
      </ion-buttons>
    </div>
    <div class="paymentType d__flex">
      <ion-buttons class="paymentType__button">
        <ion-button color="" fill="clear">
          <ion-icon src="assets/icons/Card-03.svg"></ion-icon>
          {{db.items.payment_method_name}}
        </ion-button>
      </ion-buttons>
      <ion-buttons class="deliverType__button">
        <ion-button color="" fill="clear">
          <ion-icon src="assets/icons/order-type-delivery-03.svg"></ion-icon>
          {{db.items.type}}
        </ion-button>
      </ion-buttons>
    </div>
    <div *ngIf="db.items">
      <div class="productItemList">
        <div class="order-item-title">
          <h6 class="item-image">Items</h6>
          <h6 class="item-detail"></h6>
          <h6 class="item-qty">Qty</h6>
          <h6 class="item-price">Price</h6>
          <h6 class="item-total">Total Price</h6>
        </div>
        <div class="order-detail-scroll">
          <div *ngFor="let item of db.items.Items" class="order-items-list">
            <div class="item-image"><img [src]="db.product_img(item.item_image)" alt=""></div>
            <div class="item-detail">
              <h6>{{item.item_name}}</h6>
            </div>
            <div class="item-qty">
              {{item.quantity}}
            </div>
            <div class="open_sans__font item-price">
              {{item.price|currency:db.currency}}
            </div>
            <div class="item-total open_sans__font">
              <h6>{{item.t_amount|currency:db.currency}}</h6>
            </div>
          </div>
        </div>
        <div>
          <div class="total__Price d__flex">
          </div>
          <div class="total__Price color d__flex">
            <div class="total">Total Price</div>
            <div class="price open_sans__font">{{db.items.total_amount |currency:db.currency}}</div>
          </div>
          <div class="total__Price color d__flex">
            <div class="total">Shipping Chargers</div>
            <div class="price open_sans__font">{{db.items.actual_shipping_charges |currency:db.currency}}</div>
          </div>
          <div class="total__Price bold d__flex">
            <div class="total">Order Total</div>
            <div class="price open_sans__font">{{db.items.total_amount |currency:db.currency}}</div>
          </div>
          <div class="total__Price color d__flex">
            <div class="total">Advance Amount</div>
            <div class="price open_sans__font">{{db.items.advance_amount |currency:db.currency}}</div>
          </div>
          <div class="total__Price bold d__flex">
            <div class="total">Outstanding Amount</div>
            <div class="price open_sans__font">{{db.items.outstanding_amount |currency:db.currency}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
